<template>
    <div>
        <div class="followtest">
            <el-tabs type="border-card">
                <el-tab-pane label="体温"><child4></child4></el-tab-pane>
                <el-tab-pane label="血压"><child3></child3></el-tab-pane>
                <el-tab-pane label="心率"><child5></child5></el-tab-pane>
                <el-tab-pane label="血氧"><child2></child2></el-tab-pane>
                <el-tab-pane label="血糖"><child1></child1></el-tab-pane>
                <el-tab-pane label="心电"><child6></child6></el-tab-pane>
            </el-tabs>
        </div>
  </div>
</template>
<script>
 //导入子组件
import child1 from '@/components/follow/Followtestdetail-child1';
import child2 from '@/components/follow/Followtestdetail-child2';
import child3 from '@/components/follow/Followtestdetail-child3';
import child4 from '@/components/follow/Followtestdetail-child4';
import child5 from '@/components/follow/Followtestdetail-child5';
import child6 from '@/components/follow/Followtestdetail-child6';
export default {
  data () {
    return {

    };
  },
  methods: {
       
  },
  components: {
    child1,
    child2,
    child3,
    child4,
    child5,
    child6
  },
};
</script>
<style lang="scss" scoped>
    .followtest{
        padding:10px 0;
        width:95%;
    }  
</style>
